export enum VisitPlanRouteStatusEnum {
  DRAFT = "DRAFT",
  DISPATCHED = "DISPATCHED",
PARTIAL_DISPATCHED = "PARTIAL_DISPATCHED"
}
